/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {FC, useEffect, useState, useMemo} from 'react'
import {TabLavanderiaModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {LaundryModel, PointModel, SelectModel} from '../../../../model'
import {getAppLaundry, getPoint} from '../../../../services'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {getMasterService} from '../../../../../central/services'
interface FormattedDate {
  fecha: string
  tiempo: string
}
const TableAppLaundry: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()
  const {searchValues, clearSearchValues} = useKhipu()
  const [point, setPoint] = useState<SelectModel[]>([])
  const [status, setStatus] = useState<SelectModel[]>([])

  const getFormatDate = (fechaIn: any): FormattedDate | string => {
    if (!fechaIn) {
      return ''
    }
    let fechaActual = new Date(fechaIn)
    let año: Date | any = fechaActual.getFullYear()
    let mes: Date | any = fechaActual.getMonth() + 1
    let dia: Date | any = fechaActual.getDate()
    let hora: Date | any = fechaActual.getHours()
    let minutos: Date | any = fechaActual.getMinutes()
    let segundos: Date | any = fechaActual.getSeconds()

    // Formatear la salida si es necesario
    mes = mes < 10 ? '0' + mes : mes
    dia = dia < 10 ? '0' + dia : dia
    hora = hora < 10 ? '0' + hora : hora
    minutos = minutos < 10 ? '0' + minutos : minutos
    segundos = segundos < 10 ? '0' + segundos : segundos

    // Imprimir la fecha y hora
    return {fecha: dia + '/' + mes + '/' + año, tiempo: hora + ':' + minutos + ':' + segundos}
  }
  const getAppLaundryList = async () => {
    setLoading(true)
    await new Promise((resolve) => setTimeout(resolve, 2000))
    const response = await getAppLaundry(searchValues, pagination.currentPage)
    const dataInfo = response.data?.data || []
    if (dataInfo.length > 0) {
      dataInfo.forEach((objeto) => {
        let dateReception = objeto.fechaRecepcion ? getFormatDate(objeto.fechaRecepcion) : ''
        let dateProgram = objeto.fechaEntregaProgramada
          ? getFormatDate(objeto.fechaEntregaProgramada)
          : ''
        let dateOut = objeto.fechaSalida ? getFormatDate(objeto.fechaSalida) : ''
        objeto.fechaRecepcion = dateReception ? (dateReception as FormattedDate).fecha : ''
        objeto.fechaEntregaProgramada = dateProgram ? (dateProgram as FormattedDate).fecha : ''
        objeto.fechaSalida = dateOut ? (dateOut as FormattedDate).fecha : ''
        return objeto
      })
    }

    setData(dataInfo)
    setLoading(false)
  }
  const getPointList = async () => {
    let obj: PointModel = {
      isCombo: true,
    }
    const response = await getPoint(obj, pagination.currentPage)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setPoint(mappedSites)
  }
  const getStatus = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoLavanderia',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
        codigo: master.codigo,
      }))
      setStatus(mappedMaster)
    } catch (error) {
      setStatus([])
    }
  }
  useEffect(() => {
    getPointList()
    getStatus()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getAppLaundryList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination])

  useEffect(() => {
    getAppLaundryList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])
  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-laundry-app',
      },
      idToDelete: '',
      aditionalInformation: {
        ...currentTabItem.aditionalInformation,
        order: {
          isView: true,
        },
      },
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getAppLaundryList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])
  const columns: Column<LaundryModel>[] = useMemo(
    () => [
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro de orden' name='nroOrden' searcheable />
        ),
        accessor: 'nroOrden',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Punto de Lavandería'
            data={point}
            name='puntoId'
            selecteable
          />
        ),
        accessor: 'punto',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de boleta'
            name='tipoRecepcion'
            searcheable
          />
        ),
        accessor: 'tipoRecepcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro de boleta' name='nroBoleta' searcheable />
        ),
        accessor: 'nroBoleta',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de recepción'
            name='fechaRecepcion'
            dateable
          />
        ),
        accessor: 'fechaRecepcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de entrega programada'
            name='fechaEntregaProgramada'
            dateable
          />
        ),
        accessor: 'fechaEntregaProgramada',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha de salida' name='fechaSalida' dateable />
        ),
        accessor: 'fechaSalida',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cantidad prendas'
            name='cantidadPrendas'
            searcheable
          />
        ),
        accessor: 'cantidadPrendas',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Cantidad KG' name='cantidadKG' searcheable />
        ),
        accessor: 'cantidadKG',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Bolsa' name='bolsaCorrelativo' searcheable />
        ),
        accessor: 'bolsaCorrelativo',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Rotulado' name='rotuladoCorrelativo' searcheable />
        ),
        accessor: 'rotuladoCorrelativo',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Estado' data={status} name='estado' selecteable />
        ),
        accessor: 'estadoNombre',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <div className='d-flex'>
            {isAllowed('VER') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </div>
        ),
      },
    ],
    [status, point, selectedOn, data],
  )

  useEffect(() => {
    setInitialPagination()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.loadingTable])

  const setInitialPagination = async () => {
    const {data: response} = await getAppLaundry({}, pagination.currentPage)
    setPagination({
      perPage: 10,
      currentPage: 1,
      totalResults: response.total,
    })
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {}, [data])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getAppLaundryList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])
  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='mx-2  w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableAppLaundryWrapper = () => {
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Ordenes</Tab>
          </TabList>
          <TabPanel>
            <TableAppLaundry />
          </TabPanel>
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableAppLaundryWrapper}
